// Utils & misc
import cn from '../../../utils/cn';

// Style
import style from './ItemListCard.module.css';
import footerStyle from './ItemListCardFooter.module.css';

/**
 * ItemListCard component - Displays a card with title, footer, action and custom content
 * @param {object} params
 * @param {string} params.title - Card title
 * @param {string | null} [params.subTitle] - Optional subtitle displayed below title
 * @param {React.ReactNode} [params.icon] - Optional icon displayed before the title
 * @param {React.ReactNode} [params.footer] - Footer content (links, actions, etc.)
 * @param {React.ReactNode} [params.action] - Action element (button, etc.)
 * @param {React.ReactNode} [params.children] - Render function for custom content
 * @param {string} [params.className] - Additional CSS classes
 * @returns {JSX.Element} ItemListCard component
 */
function ItemListCard({
  title,
  subTitle = null,
  icon = null,
  footer,
  action,
  children,
  className,
}) {
  return (
    <div className={cn([style['item-list-card'], className])}>
      <div className={style.header}>
        <div className={style['header-start']}>
          {icon ? (
            <div className={style.icon}>
              {icon}
            </div>
          ) : null}
          <div className={style['header-text']}>
            <h2 className={style.title}>{title}</h2>
            {subTitle ? (
              <p className={style['sub-title']}>{subTitle}</p>
            ) : null}
          </div>
        </div>
        {action ? (
          <div className={style.action}>
            {action}
          </div>
        ) : null}
      </div>

      {children}

      {footer ? (
        <div className={footerStyle.footer}>
          {footer}
        </div>
      ) : null}
    </div>
  );
}

/**
 *
 * @param {object} params
 * @param {Array<any>} params.items - Array of list items
 * @param {Function} params.children - Render function for custom content
 * @returns {JSX.Element} ItemList component
 */
export function ItemList({
  items,
  children,
}) {
  return (
    <div className={style.list}>
      {items.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={style['list-item']} key={index}>
          {children(item)}
        </div>
      ))}
    </div>
  );
}

export default ItemListCard;
